import styles from './styles.module.css';
import { Outlet, Navigate } from 'react-router-dom';
import Logo from './logo';
import SideNavBar from './sideNavBar';
import TopNavBar from './topNavBar';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from '../../auth/actions';
import Footer from './footer';
import React from 'react';

const Layout = ({ auth: { isAuthenticated }, logout }) => {
  return true ? (
    <div className={styles.flexContainer}>
      <div className={styles.leftContainer}>
        <div className={styles.logoContainer}>
          <Logo />
        </div>
        <div className={styles.sideNavBarContainer}>
          <SideNavBar />
        </div>
      </div>
      <div className={styles.rightContainer}>
        <div className={styles.topNavBarOuter}>
          <TopNavBar logout={logout} />
        </div>
        <div className={styles.contentWrap}>
          <div className={styles.outletWrap}>
            <Outlet />
          </div>
          <div className={styles.footerWrap}>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <Navigate to="/login" />
  );
};

Layout.propTypes = {
  logout: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.authState,
});

export default connect(mapStateToProps, { logout })(Layout);
